// eslint-disable-next-line
export default [
	{
		id: 1,
		name: 'coke zero',
		name_alcohol: 'Amarula',
		variant: '30CL',
		price: 350,
		image: '/svgs/coke.svg',
		productQuantity: 104,
		isPromo: true,
		slug: 'coke-zero',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 2,
		name: 'yoghurt',
		name_alcohol: 'Jack Daniels',
		variant: '50CL',
		price: 700,
		image: '/svgs/coke.svg',
		productQuantity: 35,
		isPromo: false,
		slug: 'yoghurt',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 3,
		name: 'chivita',
		name_alcohol: 'Johnny Walker',
		variant: '35CL',
		price: 800,
		image: '/svgs/coke.svg',
		productQuantity: 0,
		isPromo: true,
		slug: 'chivita',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 4,
		name: 'cocacola',
		name_alcohol: 'Tequila',
		variant: '30CL',
		price: 350,
		image: '/svgs/coke.svg',
		productQuantity: 104,
		isPromo: false,
		slug: 'cocacola',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 5,
		name: 'fayrouz',
		name_alcohol: 'Vodka',
		variant: '50CL',
		price: 700,
		image: '/svgs/coke.svg',
		productQuantity: 35,
		isPromo: true,
		slug: 'fayrouz',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 6,
		name: 'amstel malt',
		name_alcohol: '8PM',
		variant: '35CL',
		price: 800,
		image: '/svgs/coke.svg',
		productQuantity: 10,
		isPromo: false,
		slug: 'amstel-malt',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 7,
		name: 'chi exotic',
		name_alcohol: 'Whiskey',
		variant: '30CL',
		price: 350,
		image: '/svgs/coke.svg',
		productQuantity: 104,
		isPromo: true,
		slug: 'chi-exotic',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 8,
		name: 'Sprite',
		name_alcohol: 'Jameson',
		variant: '50CL',
		price: 700,
		image: '/svgs/coke.svg',
		productQuantity: 35,
		isPromo: false,
		slug: 'sprite',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 9,
		name: 'Fanta',
		name_alcohol: 'Don Julio 1964',
		variant: '35CL',
		price: 800,
		image: '/svgs/coke.svg',
		productQuantity: 10,
		isPromo: true,
		slug: 'fanta',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 10,
		name: 'Hollandia',
		name_alcohol: 'Azul',
		variant: '30CL',
		price: 350,
		image: '/svgs/coke.svg',
		productQuantity: 104,
		isPromo: false,
		slug: 'hollandia',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 11,
		name: 'Vitamilk',
		name_alcohol: 'Best cream',
		variant: '50CL',
		price: 700,
		image: '/svgs/coke.svg',
		productQuantity: 35,
		isPromo: true,
		slug: 'vitamilk',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 12,
		name: 'smoothie',
		name_alcohol: 'Magaritta',
		variant: '35CL',
		price: 800,
		image: '/svgs/coke.svg',
		productQuantity: 10,
		isPromo: false,
		slug: 'smoothie',
		image_alcohol: '/svgs/alcohol_icon.svg',
	},
	{
		id: 13,
		name: 'Coke zero',
		name_alcohol: 'Amarula',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: true,
		slug: '',
	},
	{
		id: 14,
		name: 'Yoghurt',
		name_alcohol: 'Jack Daniels',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: false,
		slug: '',
	},
	{
		id: 15,
		name: 'Chivita',
		name_alcohol: 'Johnny Walker',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 0,
		isPromo: true,
		slug: '',
	},
	{
		id: 16,
		name: 'Coke zero',
		name_alcohol: 'Tequila',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: false,
		slug: '',
	},
	{
		id: 17,
		name: 'Yoghurt',
		name_alcohol: 'Vodka',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: true,
		slug: '',
	},
	{
		id: 18,
		name: 'Chivita',
		name_alcohol: '8PM',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 10,
		isPromo: false,
		slug: '',
	},
	{
		id: 19,
		name: 'Coke zero',
		name_alcohol: 'Whiskey',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: true,
		slug: '',
	},
	{
		id: 20,
		name: 'Yoghurt',
		name_alcohol: 'Jameson',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: false,
		slug: '',
	},
	{
		id: 21,
		name: 'Chivita',
		name_alcohol: 'Don Julio 1964',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 10,
		isPromo: true,
		slug: '',
	},
	{
		id: 22,
		name: 'Coke zero',
		name_alcohol: 'Azul',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: false,
		slug: '',
	},
	{
		id: 23,
		name: 'Yoghurt',
		name_alcohol: 'Best cream',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: true,
		slug: '',
	},
	{
		id: 24,
		name: 'Chivita',
		name_alcohol: 'Magaritta',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 10,
		isPromo: false,
		slug: '',
	},
	{
		id: 25,
		name: 'Coke zero',
		name_alcohol: 'Amarula',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: true,
		slug: '',
	},
	{
		id: 26,
		name: 'Yoghurt',
		name_alcohol: 'Jack Daniels',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: false,
		slug: '',
	},
	{
		id: 27,
		name: 'Chivita',
		name_alcohol: 'Johnny Walker',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 0,
		isPromo: true,
		slug: '',
	},
	{
		id: 28,
		name: 'Coke zero',
		name_alcohol: 'Tequila',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: false,
		slug: '',
	},
	{
		id: 29,
		name: 'Yoghurt',
		name_alcohol: 'Vodka',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: true,
		slug: '',
	},
	{
		id: 30,
		name: 'Chivita',
		name_alcohol: '8PM',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 10,
		isPromo: false,
		slug: '',
	},
	{
		id: 31,
		name: 'Coke zero',
		name_alcohol: 'Whiskey',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: true,
		slug: '',
	},
	{
		id: 32,
		name: 'Yoghurt',
		name_alcohol: 'Jameson',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: false,
		slug: '',
	},
	{
		id: 33,
		name: 'Chivita',
		name_alcohol: 'Don Julio 1964',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 10,
		isPromo: true,
		slug: '',
	},
	{
		id: 34,
		name: 'Coke zero',
		name_alcohol: 'Azul',
		price: 350,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 104,
		isPromo: false,
		slug: '',
	},
	{
		id: 35,
		name: 'Yoghurt',
		name_alcohol: 'Best cream',
		price: 700,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 35,
		isPromo: true,
		slug: '',
	},
	{
		id: 36,
		name: 'Chivita',
		name_alcohol: 'Magaritta',
		price: 800,
		image: '/svgs/coke.svg',
		image_alcohol: '/svgs/alcohol_iconhol_icon.svg',
		productQuantity: 10,
		isPromo: false,
		slug: '',
	},
];
